import { INPUT_COUNTER_BUILD_SCREEN_READER_CURRENT_CHARACTERS_KEY, INPUT_COUNTER_BUILD_SCREEN_READER_MAX_LENGTH_KEY, } from '../types/input';
export const getCharactersLength = (value, ref) => {
    if (value !== undefined) {
        return value?.toString().length;
    }
    return (ref?.current?.value?.length || 0);
};
export const buildScreenReaderText = (value, ref, maxLength, screenReaderText) => {
    if (!screenReaderText) {
        return screenReaderText;
    }
    const currentCharacters = getCharactersLength(value, ref);
    const currentCharactersRegExp = new RegExp(INPUT_COUNTER_BUILD_SCREEN_READER_CURRENT_CHARACTERS_KEY, 'g');
    const maxlengthRegExp = new RegExp(INPUT_COUNTER_BUILD_SCREEN_READER_MAX_LENGTH_KEY, 'g');
    return screenReaderText
        .replace(currentCharactersRegExp, String(currentCharacters))
        .replace(maxlengthRegExp, String(maxLength));
};
//# sourceMappingURL=counter.utils.js.map